export default __webpack_public_path__ + "src/images/galleries/1/menu_cn-7fa8b8.png";